import { FunctionComponent, PropsWithChildren } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS, mobileCSS } from '@measures/responsive'
import useClientViewportType from '@hooks/useClientViewportType'
import { HeroModuleAPIProps } from '@widgets/HeroModule'
import Blink, { BlinkProps } from '@components/Blink'

type ImmersiveDynamicContentWrapperProps = PropsWithChildren<BlinkProps> & {
  typeOfSport: HeroModuleAPIProps['typeOfSport']
  isSportDataLoaded: boolean
}

const StyledImmersiveDynamicContentWrapper = styled(Blink)<{
  typeOfSport: HeroModuleAPIProps['typeOfSport']
  isSportDataLoaded: boolean
}>`
  display: block;
  appearance: none;
  text-decoration: none;

  ${desktopCSS(css`
    display: none;
  `)}

  ${mobileCSS(css`
    margin-left: -16px;
    margin-right: -16px;
  `)};
`

const ImmersiveDynamicContentWrapper: FunctionComponent<
  ImmersiveDynamicContentWrapperProps
> = ({ typeOfSport, isSportDataLoaded, children, ...restOfProps }) =>
  useClientViewportType() === 'desktop' ? null : (
    <StyledImmersiveDynamicContentWrapper
      typeOfSport={typeOfSport}
      isSportDataLoaded={isSportDataLoaded}
      {...restOfProps}
    >
      {children}
    </StyledImmersiveDynamicContentWrapper>
  )

export default ImmersiveDynamicContentWrapper
